import { Button } from './src/Button'
export { Button }
export default Button



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/components/Button/index.ts